// extracted by mini-css-extract-plugin
module.exports = {"theComp":"TabMedia_theComp___w5_K"};